import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import style from "./style.module.scss";
export default function ModalFooter(props) {
    return (_jsxs("div", { className: style["modal-footer"], children: [_jsx("div", { children: props.children }), _jsx("div", { children: props.rightContent })] }));
}
